import { render, staticRenderFns } from "./DatePeriodSelect.vue?vue&type=template&id=143e77b8&scoped=true&"
import script from "./DatePeriodSelect.vue?vue&type=script&lang=ts&"
export * from "./DatePeriodSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e77b8",
  null
  
)

export default component.exports